import React from 'react'; 
import CategoryMenus from './CategoryMenus';
import CategoryThumbs from './CategoryThumbs';
import { Link } from 'react-router-dom';
import WithConsumer from '../../context/WithConsumer';

const News = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxDoRender = () => context.doRender;
    const doRender = ctxDoRender();
  	
    if (post && doRender) {

	    let pageClass = 'c-page c-page--' + post.slug;
	    
	    if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
	    }
				
		return (
			<>
					
				<div className={pageClass}>
					<div className="c-page__inner">
						{post.categories &&
							<CategoryMenus post={post}></CategoryMenus>
						}
						{post.thumbs &&
							<CategoryThumbs thumbs={post.thumbs} thumbStyle={post.thumb_style}></CategoryThumbs>	
						}
					</div>
				</div>
				
			</>
		)
					
	} else {
		return null;
	}
};
export default WithConsumer(News);